// extracted by mini-css-extract-plugin
export default {"bgLogin":"PageInfo_bgLogin__NBHJF","mainPageInfo":"PageInfo_mainPageInfo__rHjpk","titlePage":"PageInfo_titlePage__+TmCg","imageContentSoon":"PageInfo_imageContentSoon__DCWpV"};